import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoTabDataIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M-7806 -3234H11039V-3254H-7806V-3234ZM11031 -3242V9330H11051V-3242H11031ZM11039 9322H-7806V9342H11039V9322ZM-7798 9330V-3242H-7818V9330H-7798ZM-7806 9322C-7801.58 9322 -7798 9325.58 -7798 9330H-7818C-7818 9336.63 -7812.63 9342 -7806 9342V9322ZM11031 9330C11031 9325.58 11034.6 9322 11039 9322V9342C11045.6 9342 11051 9336.63 11051 9330H11031ZM11039 -3234C11034.6 -3234 11031 -3237.58 11031 -3242H11051C11051 -3248.63 11045.6 -3254 11039 -3254V-3234ZM-7806 -3254C-7812.63 -3254 -7818 -3248.63 -7818 -3242H-7798C-7798 -3237.58 -7801.58 -3234 -7806 -3234V-3254Z",
			fill: "black",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5108_8805)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 1440,
					height: 1024,
					transform: "translate(-726 -344)",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 200,
					height: 140,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 89.6406,
					cy: 120.66,
					r: 6,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.75 41.5V51H133.25V41.5C133.25 38.8727 131.127 36.75 128.5 36.75H71.5C68.8727 36.75 66.75 38.8727 66.75 41.5ZM66.75 55.75V72.375H97.625V55.75H66.75ZM66.75 77.125V89C66.75 91.6273 68.8727 93.75 71.5 93.75H97.625V77.125H66.75ZM102.375 55.75V72.375H133.25V55.75H102.375ZM102.375 77.125V93.75H128.5C131.127 93.75 133.25 91.6273 133.25 89V77.125H102.375Z",
					fill: "url(#paint0_linear_5108_8805)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 40.6406,
					cy: 35.6602,
					r: 8,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M71.5 36.75C68.8727 36.75 66.75 38.8727 66.75 41.5V51H133.25V41.5C133.25 38.8727 131.127 36.75 128.5 36.75H71.5ZM66.75 55.75V72.375H97.625V55.75H66.75ZM102.375 55.75V72.375H133.25V55.75H102.375ZM97.625 77.125H66.75V89C66.75 91.6273 68.8727 93.75 71.5 93.75H97.625V77.125ZM102.375 93.75H128.5C131.127 93.75 133.25 91.6273 133.25 89V77.125H102.375V93.75ZM62 41.5C62 36.2602 66.2602 32 71.5 32H128.5C133.74 32 138 36.2602 138 41.5V89C138 94.2398 133.74 98.5 128.5 98.5H71.5C66.2602 98.5 62 94.2398 62 89V41.5Z",
					fill: "url(#paint1_linear_5108_8805)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M113.333 98C113.333 105.364 107.364 111.333 100 111.333C92.6362 111.333 86.6666 105.364 86.6666 98C86.6666 90.6362 92.6362 84.6667 100 84.6667C107.364 84.6667 113.333 90.6362 113.333 98Z",
					fill: "#DB5543",
					stroke: "white",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M100 90.3333C100.552 90.3333 101 90.781 101 91.3333V99.3333C101 99.8856 100.552 100.333 100 100.333C99.4477 100.333 99 99.8856 99 99.3333V91.3333C99 90.781 99.4477 90.3333 100 90.3333ZM100 102.333C100.552 102.333 101 102.781 101 103.333V104.667C101 105.219 100.552 105.667 100 105.667C99.4477 105.667 99 105.219 99 104.667V103.333C99 102.781 99.4477 102.333 100 102.333Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.3999 40.8C66.3999 38.5908 68.1908 36.8 70.3999 36.8H129.4C131.609 36.8 133.4 38.5908 133.4 40.8V51H66.3999V40.8Z",
					fill: "url(#paint2_linear_5108_8805)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5108_8805",
				x1: 100,
				y1: 36.75,
				x2: 100,
				y2: 93.75,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5108_8805",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 98.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5108_8805",
				x1: 66.3999,
				y1: 43.9,
				x2: 133.4,
				y2: 43.9,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_5108_8805",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 1440,
					height: 1024,
					fill: "white",
					transform: "translate(-726 -344)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoTabDataIcon);
export { ForwardRef as ReactComponent };
